export default __webpack_public_path__ + "static/media/005-air pollution.5a30bbc3.svg";